<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div class="grid" *ngIf="!carInformacionInicial">
  <div class="col-12">
    <p-panel header="{{ 'SEGURO.LBL_INFORMACIONSEGURO' | translate}}" >
      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_CODSEGU' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8 "><strong>{{seguro.codigo}}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_NOMSEGU' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.nombre}}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_POLIZAMAESTRA' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8 "><strong>{{seguro.polizaMaestra}}</strong></label>
      </div>
      <div class="grid flex align-items-center">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_DESCRIPCION' | translate }}:</label>
        <label class="lg:col-10 col-6 md:col-8 "><strong [innerHTML]="seguro.descripcion | safeHtml"></strong></label>
      </div>
      <div class="grid flex align-items-center">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGUROCOBERTURAS.LBL_DESCRIPCION' | translate }}:</label>
        <label class="lg:col-10 col-6 md:col-8 "><strong [innerHTML]="seguro.descripcionCobertura | safeHtml"></strong></label>
      </div>
      <div class="grid flex align-items-center">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_DESCRIPCIONBILLETERA' | translate }}:</label>
        <label class="lg:col-10 col-6 md:col-8 "><strong [innerHTML]="seguro.descripcionBilletera !== null ? seguro.descripcionBilletera : '' | safeHtml"></strong></label>
      </div>
      <div class="grid flex align-items-center">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGUROCOBERTURAS.LBL_DESCRIPCIONBILLETERA' | translate }}:</label>
        <label class="lg:col-10 col-6 md:col-8 "><strong [innerHTML]="seguro.descripcionCoberturaBilletera !== null ? seguro.descripcionCoberturaBilletera : '' | safeHtml"></strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_TASA' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorTasa ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_VALORTASA' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8 "><strong>{{seguro.valorTasa}}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_NATURALEZA' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8 "><strong>{{segurosTipoPersonas}}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_BENEFI' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorBeneficiarios ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
        <ng-container *ngIf="seguro.indicadorBeneficiarios">
          <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_BENEFICIARIOLEY' | translate }}:</label>
          <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorBeneficiariosLey ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate) }}</strong></label>
        </ng-container>
      </div>
      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_DECLRIES' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorDeclaracionRiesgo ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate)}}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_CUESTIONARIO' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8 "><strong>{{seguro.nombreCuestionario}}</strong></label>

      </div>
      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_REQUIREIMC' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorRequiereImc ? ('LBL_SI' | translate) : ('LBL_NO' |  translate) }}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_ASEGURANEGOCIO' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorAseguraNegocio ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_ASEGURACASA' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorAseguraHogar ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_ASEGURACONTENIDONEGOCIO' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorAseguraContenidoNegocio ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'SEGURO.LBL_ASEGURACONTENIDOHOGAR' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorAseguraContenidoHogar ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate) }}</strong></label>
      </div>

      <div class="grid">
        <label class="lg:col-2 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
        <label class="lg:col-2 col-6 md:col-8"><strong>{{seguro.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate)}}</strong></label>
      </div>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel header="{{ 'SEGURO.LBL_PLANES' | translate}}" *ngIf="!seguro.indicadorTasa">
      <div class="grid" >
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="carTabla" #dt
                   [value]="lisSegurosPlan" selectionMode="single" dataKey="nombre"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.codigo}}</td>
                <td>{{row.nombre}}</td>
                <td>{{row.valor | dinero}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
  </div>
  <div class="col-12">
    <div class="grid form-footer-buttons" *ngIf="seguro && seguro.idSeguro">
      <div class="form-group col-12">
        <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                pButton (click)="regresar(false)"></button>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
